window.initSizeGuidePanel = () => {
  const panel = document.getElementById("size-panel")
  if (!panel) return

  // Cache element collections
  const openButtons = document.querySelectorAll("[data-size-panel-open]")
  const closeButtons = panel.querySelectorAll("[data-size-panel-close]")
  const unitButtons = panel.querySelectorAll(".size-unit-switch button")
  const sizeCells = panel.querySelectorAll("td[data-cm]")

  // Use a shared handler to reduce duplicate functions
  const togglePanel = open => {
    panel.classList.toggle("open", open)
    panel.setAttribute("aria-hidden", String(!open))
  }

  // Delegate opening logic
  openButtons.forEach(btn =>
    btn.addEventListener("click", () => togglePanel(true), { passive: true })
  )

  // Delegate closing logic
  closeButtons.forEach(btn =>
    btn.addEventListener("click", () => togglePanel(false), { passive: true })
  )

  // Toggle size unit between cm/in
  unitButtons.forEach(btn => {
    btn.addEventListener(
      "click",
      () => {
        const unit = btn.dataset.unit

        // Batch class updates using forEach and minimal DOM writes
        unitButtons.forEach(b => {
          const isActive = b === btn
          b.classList.toggle("btn-primary", isActive)
          b.classList.toggle("btn-secondary", !isActive)
          b.classList.toggle("active", isActive)
        })

        // Update text content efficiently
        sizeCells.forEach(cell => {
          const val = cell.dataset[unit]
          if (val !== undefined) cell.textContent = `${val} ${unit}`
        })
      },
      { passive: true }
    )
  })
}
